import { FETCH_WHATSNEW, GET_WHATSNEW, CREATE_WHATSNEW, UPDATE_WHATSNEW, DELETE_WHATSNEW } from 'actions/whatsNew';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  whatsNewList: [],
  whatsNewDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const whatsNewReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_WHATSNEW.REQUEST:
    case GET_WHATSNEW.REQUEST:
    case CREATE_WHATSNEW.REQUEST:
    case UPDATE_WHATSNEW.REQUEST:
    case DELETE_WHATSNEW.REQUEST:
      return { ...state, isLoading: true };

    case FETCH_WHATSNEW.SUCCESS:
      return {
        ...state,
        isLoading: false,
        whatsNewList: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };

    case GET_WHATSNEW.SUCCESS:
      return { ...state, isLoading: false, whatsNewDetail: payload };

    case CREATE_WHATSNEW.SUCCESS:
      toast.success("What's New added successfully");
      return { ...state, isLoading: false, whatsNewList: _.concat(state.whatsNewList, payload) };

    case UPDATE_WHATSNEW.SUCCESS:
      toast.success("What's New updated successfully");
      return {
        ...state,
        isLoading: false,
        whatsNewList: state.whatsNewList.map((item) => (item.id === payload.id ? payload : item)),
      };

    case DELETE_WHATSNEW.SUCCESS:
      toast.success("What's New deleted successfully");
      return {
        ...state,
        isLoading: false,
        whatsNewList: state.whatsNewList.filter((item) => item.id !== payload),
      };

    case FETCH_WHATSNEW.FAIL:
    case GET_WHATSNEW.FAIL:
    case CREATE_WHATSNEW.FAIL:
    case UPDATE_WHATSNEW.FAIL:
    case DELETE_WHATSNEW.FAIL:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};

export default whatsNewReducer;
